import React from 'react'
import ScatterPlot from './ScatterPlot'
import ScatterGuides from './ScatterGuides'
// import createMeasurements from './Measurements'
import R from 'ramda'
import { scaleLinear } from 'd3-scale'
import { extent } from 'd3-array'
import RegressionLine from './RegressionLine'

export const createGetter = ({ key, getter }) => data =>
  getter ? getter(data) : data[key]

class Scatter extends React.Component {
  constructor(props) {
    super(props)
    this.state = { selectDot: undefined }
    this.selectDot = this.selectDot.bind(this)
  }

  selectDot(dot) {
    this.setState({ selectedDot: dot })
  }

  render() {
    const {
      xValKey = 'xValue',
      yValKey = 'yValue',
      rValKey = 'rValue',
      fValKey = 'fValue',
      xValGetter,
      yValGetter,
      rValGetter,
      fValGetter,
      xScale = scaleLinear(),
      yScale = scaleLinear(),
      useXDataMin = false,
      useYDataMin = false,
      renderEmpty = () => <div>No Data</div>,
      showLinearRegression,
      renderExtra,
      ...rest
    } = this.props

    // stuff that still needs to be pushed down
    const { data, measurement } = this.props
    const { innerWidth, innerHeight } = measurement

    const xGetter = createGetter({ key: xValKey, getter: xValGetter })
    const yGetter = createGetter({ key: yValKey, getter: yValGetter })
    const rGetter = createGetter({ key: rValKey, getter: rValGetter })
    const fGetter = createGetter({ key: fValKey, getter: fValGetter })
    if (R.isNil(data) || data.length === 0) return renderEmpty()

    const x = xScale.range([0, innerWidth])
    const y = yScale.range([innerHeight, 0])
    const [xMin, xMax] = extent(data, xGetter)
    const [yMin, yMax] = extent(data, yGetter)
    x.domain([useXDataMin ? xMin : 0, xMax])
    y.domain([useYDataMin ? yMin : 0, yMax])

    const commonProps = {
      ...rest,
      xGetter,
      yGetter,
      rGetter,
      fGetter,
      x,
      y,
      yMin,
      yMax,
      xMin,
      xMax,
    }

    return [
      <ScatterGuides
        dot={this.state.selectedDot}
        key="guides"
        {...commonProps}
      />,
      <ScatterPlot
        onDotSelect={this.selectDot}
        key="scatter"
        {...commonProps}
      />,
      showLinearRegression && (
        <RegressionLine key="regression" {...commonProps} />
      ),
      renderExtra && renderExtra(commonProps),
    ]
  }
}

//
export default Scatter
